import React from 'react'
import Payment from '../../Components/User/Bookings/payment'

function PaymentPages() {
  return (
    <div>
       <Payment/>
    </div>
  )
}

export default PaymentPages
